const config = {
    // URL de base de l'API
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
     
    // Autres paramètres de configuration
    APP_NAME: process.env.REACT_APP_APP_NAME,
    VERSION: process.env.REACT_APP_VERSION,
  
      
};
    
  
  export default config;